import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNotepad: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNotepad"><Path fillRule="evenodd" clipRule="evenodd" d="M8.5 1.5V2.52778H11.25V1.5H12.75V2.52778H15.5V1.5H17V2.52778H20.5V21.5H3.5V2.52778H7V1.5H8.5ZM8 9H16V10.5H8V9ZM8 13H14V14.5H8V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNotepad;
